import { grantPermissionsToTenant } from '@infuse/api/iam/tenant';
import { useGenericGrantPermission } from '@infuse/iam/permission/mutations';

export const useGrantPermissionToTenant = () => {
  return useGenericGrantPermission({
    apiFn: grantPermissionsToTenant
  });
};
